<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <kds-user-form :route="route" @on-submit="onUserSubmit"></kds-user-form>
    </div>
  </div>
</template>
<script>
  import KdsUserForm from './KdsUserForm.vue'
  export default {
    components: {
      KdsUserForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        orderPosModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.orderPosModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/Users/KdsUserEdit.vue